import { createSlice } from '@reduxjs/toolkit';
import { locationsApi } from '@store/rtk/locations';
import { Table2Data, TableData } from '@uikit/Tables/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type LocationHoursDataType = {
  id: number;
  covered_indicator?: boolean;
  table_name?: string | null;
  field_name?: string | null;
  weekDay?: {
    id: number;
    name: string;
  };
  time?: {
    id: number;
    name: string;
  };
  associated_id?: number;
};

interface PlacesLocationState {
  locationHoursData: LocationHoursDataType | null;
  locationServicesData: Table2Data;
  locationAdmittedData: TableData;
  locationViewsData: TableData;
}
const { locationAdmittedColumns, locationViewsColumns } = TABLE_COLUMNS;

const initialState: PlacesLocationState = {
  locationHoursData: null,
  locationServicesData: {
    titles: [
      {
        id: '1',
        title: 'Service Category',
        fieldName: 'serviceCategory',
        type: 'string',
      },
      {
        id: '2',
        title: 'Service Type',
        fieldName: 'serviceType',
        type: 'string',
      },
      {
        id: '3',
        title: '',
        fieldName: 'active',
        type: 'string',
      },
      {
        id: '4',
        title: 'Audit',
        fieldName: 'audit',
        type: 'string',
      },
    ],
    rows: [
      {
        id: '1',
        serviceCategory: 'Discharge',
        serviceType: 'From an acute care hospital',
        active: '',
        audit: '',
      },
      {
        id: '2',
        serviceCategory: 'Discharge',
        serviceType: 'Skilled nursing facility discharge',
        active: '',
        audit: '',
      },
      {
        id: '3',
        serviceCategory: 'Life-sustaining',
        serviceType: 'Hemodialysis',
        active: '',
        audit: '',
      },
      {
        id: '4',
        serviceCategory: 'Life-sustaining',
        serviceType: 'Chemotherapy',
        active: '',
        audit: '',
      },
      {
        id: '5',
        serviceCategory: 'Discharge',
        serviceType: 'Acute care hospital discharge',
        active: '',
        audit: '',
      },
      {
        id: '6',
        serviceCategory: 'Discharge',
        serviceType: 'Skilled nursing facility discharge',
        active: '',
        audit: '',
      },
      {
        id: '7',
        serviceCategory: 'General service',
        serviceType: 'Primary care visit',
        active: '',
        audit: '',
      },
      {
        id: '8',
        serviceCategory: 'General service',
        serviceType: 'Prescription pickup',
        active: '',
        audit: '',
      },
    ],
  },
  locationAdmittedData: {
    columns: locationAdmittedColumns,
    // rows: [
    //   {
    //     id: '1',
    //     memberId: '9999911C',
    //     memberName: 'Michael Jordan',
    //     client: 'L.A. Care Health Plan',
    //     admitted: '06/27/2024 13:15',
    //     estDischarge: '06/27/2024 13:15',
    //     expectedMode: 'Gurney',
    //     estDischaschedulerge: 'Ike Turner (9999954D)',
    //     schedule: true,
    //   },
    //   {
    //     id: '1',
    //     memberId: '9999911C',
    //     memberName: 'Michael Jordan',
    //     client: 'L.A. Care Health Plan',
    //     admitted: '06/27/2024 13:15',
    //     estDischarge: '06/27/2024 13:15',
    //     expectedMode: 'Gurney',
    //     estDischaschedulerge: 'Ike Turner (9999954D)',
    //     schedule: true,
    //   },
    //   {
    //     id: '3',
    //     memberId: '9999911C',
    //     memberName: 'Michael Jordan',
    //     client: 'L.A. Care Health Plan',
    //     admitted: '06/27/2024 13:15',
    //     estDischarge: '06/27/2024 13:15',
    //     expectedMode: 'Gurney',
    //     estDischaschedulerge: 'Ike Turner (9999954D)',
    //     schedule: false,
    //   },
    // ],
    rows: [],
    size: 5,
  },
  locationViewsData: {
    columns: locationViewsColumns,
    rows: [
      {
        id: '1',
        ip_address: '32.132.132.1',
        location: 'Pomona, California USA',
        viewed: '05/15/2024 05:00 PDT',
        viewed_by: 'Michael L. (lujanom)',
        role: 'Core user',
      },
      {
        id: '2',
        ip_address: '27.127.127.0',
        location: 'Los angeles, California, USA',
        viewed: '05/15/2024 05:00 PDT',
        viewed_by: 'George G. (glassg)',
        role: 'Places portal user',
      },
      {
        id: '3',
        ip_address: '32.132.132.1',
        location: 'Pomona, California USA',
        viewed: '05/13/2024 13:01 PDT',
        viewed_by: 'Marvin T. (marvint)',
        role: 'Core user',
      },
    ],
  },
};

export const placesLocationSlice = createSlice({
  name: 'placesLocation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      locationsApi.endpoints.getPlacesLocationHours.matchFulfilled,
      (state, { payload }) => {
        state.locationHoursData = payload;
      }
    );
    // TODO open when we discucced about this table
    // builder.addMatcher(
    //   locationsApi.endpoints.getPlaceLocationServices.matchFulfilled,
    //   (state, { payload }) => {
    //     if (payload.content && Array.isArray(payload.content)) {
    //       state.locationServicesData = {
    //         ...state.factoringAgreementData,
    //         rows: payload.content,
    //         last: payload.last,
    //         page: payload.page,
    //         size: payload.size,
    //         totalElements: payload.totalElements,
    //         totalPages: payload.totalPages,
    //       };
    //     }
    //   }
    // );
    builder.addMatcher(
      locationsApi.endpoints.getPlaceLocationAdmitted.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.locationAdmittedData = {
            ...state.locationAdmittedData,
            rows: payload.content,
            last: payload.last,
            page: payload.page,
            size: payload.size,
            totalElements: payload.totalElements,
            totalPages: payload.totalPages,
          };
        }
      }
    );
    builder.addMatcher(
      locationsApi.endpoints.getPlaceLocationViews.matchFulfilled,
      (state, { payload }) => {
        state.locationViewsData = {
          ...state.locationViewsData,
          rows: [...payload.content],
          ...payload,
          requestTablePageChange: locationsApi.endpoints.getPlaceLocationViews,
        };
      }
    );
  },
});

export const selectPlacesLocation = (state: {
  placesLocation: PlacesLocationState;
}) => state.placesLocation;
export const placesLocationReducer = placesLocationSlice.reducer;
